export const getCategoriesData = ({listsAssessmentId, ratingDataAssessmentId}) => listsAssessmentId.map(listItem => {
  const percentage = ratingDataAssessmentId.find(rate => listItem.selector === rate.selector)?.percentage || 0
  return {
    percentage,
    ...listItem
  }
}).sort((a, b) => b.category.localeCompare(a.category))